import { Dialog, DialogContent, DialogTitle, Typography, IconButton, useMediaQuery } from "@mui/material"
import VideoEditor from "../video-player/video-player"
import DownloadIcon from '@mui/icons-material/Download'

export default function VideoDialog({ title, src, isOpen, onClose }) {
    const handleDownload = () => {        
        const link = document.createElement('a')        
        link.href = src
        link.download = `${title}.mp4`

        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
    }
    const isMobile = useMediaQuery('(max-width: 900px)')

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={
                
                isMobile
                ? {
                    "& .MuiDialog-paper": {
                        margin: 1,
                        width: "95vw",
                        height: "auto",
                        maxHeight: "95vh",
                        borderRadius: "10px",
                        backgroundColor: "var(--background-primary)",
                        color: "var(--text-primary)",
                    }
                }
                : {"& .MuiDialog-paper": {

                        backgroundColor: "var(--background-primary)",
                        color: "var(--text-primary)",
                    }}
            }
        >
            <DialogTitle>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ flex: 1 }} variant="h6" sx={{ fontWeight: "bold" }}>
                        {title}
                    </Typography>
                    <IconButton style={{color: 'var(--text-primary)'}} onClick={handleDownload}>
                        <DownloadIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent style={{ padding: 0, backgroundColor: 'black' }}>
                <VideoEditor src={src} />
            </DialogContent>

        </Dialog>
    )
}
